export default function Button({
  style,
  title,
  onClick,
  type = "button",
  loading = false,
  fullWidth = false,
  disabled = false,
  form,
}: {
  style: "primary" | "secondary" | "danger";
  title: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  type?: "button" | "submit" | "reset";
  loading?: boolean;
  fullWidth?: boolean;
  disabled?: boolean;
  form?: string;
}) {
  const primaryClasses =
    "inline-flex items-center rounded-md bg-primary-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600 disabled:opacity-50 disabled:cursor-not-allowed";

  const secondaryClasses =
    "inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-primary-700 hover:text-white disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white disabled:hover:text-gray-900";

  let classes = "";
  switch (style) {
    case "primary":
      classes = primaryClasses;
      break;
    case "secondary":
      classes = secondaryClasses;
      break;
    case "danger":
      classes =
        "inline-flex items-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600 disabled:opacity-50 disabled:cursor-not-allowed";
      break;
    default:
      classes = primaryClasses;
  }

  return (
    <button
      type={type}
      className={`${classes} ${fullWidth ? "w-full justify-center" : ""}`}
      onClick={onClick}
      disabled={loading || disabled}
      form={form}
    >
      {loading ? (
        <div className="flex items-center gap-2">
          <svg
            className="animate-spin h-4 w-4 text-current"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
          {title}
        </div>
      ) : (
        title
      )}
    </button>
  );
}
